import { Tag, Button } from "antd";
import { RedoOutlined } from "@ant-design/icons";

import { useEffect, useState } from "react";

const columns = [
  {
    title: "Id",
    dataIndex: "partner_id",
    key: "partner_id",
  },

  {
    title: "Developer Name",
    dataIndex: "partner_name",
    key: "partner_name",
  },

  {
    title: "Mobile",
    dataIndex: "partner_mobile",
    key: "partner_mobile",
  },
  {
    title: "Landline",
    dataIndex: "partner_landline",
    key: "partner_landline",
  },
  {
    title: "Email Address",
    dataIndex: "partner_email",
    key: "partner_email",
  },
  {
    title: "Status",
    dataIndex: "partner_status",
    key: "partner_status",
    render: (partner_status) =>
      partner_status && partner_status !== "0" ? (
        <Tag color="green">Active</Tag>
      ) : (
        <Tag color="orange">Archived</Tag>
      ),
  },
];

export default function useGetPropertyDeveloperColumns(
  onClickRestoreDeveloper
) {
  const [tableColumns, setColumns] = useState(columns);

  useEffect(() => {
    setColumns([
      ...columns,
      {
        dataIndex: "partner_id",
        title: "Actions",
        render: (id, row) => (
          <Button
            size="small"
            type="link"
            icon={<RedoOutlined />}
            onClick={() => onClickRestoreDeveloper(id)}
            disabled={row.partner_status !== "0" ? true : false}
          />
        ),
      },
    ]);
  }, []);

  return tableColumns;
}
